import React from "react";
import { push } from "react-router-redux";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import { Button, Search } from "app/modules/shared/components/index";
import {
  Pagination,
  SearchFilter
} from "app/modules/shared/components/Pagination/index";
import CreateButton from "MODULES/Consignments/Search/Create/CreateButton";
import { stringify } from "query-string";
import { ADMIN, EXPORT_LIMIT } from "MODULES/users/constants";
import useCurrentUser from "APP_ROOT/hooks/useCurrentUser";
import { hasRole } from "MODULES/users/helpers";
import { API_BASE } from "APP_ROOT/constants";
import { renderIf } from "MODULES/shared/decorators";
import { toastr } from "react-redux-toastr";
import api from "APP_ROOT/api";
import { SUCCESS } from "LIB/submission";
import Table from "./Table";
import { consignmentsPagination } from "../pagination";

const ExportButton = ({ searchProps }) => {
  const params = searchProps.paginator.get("filters").toJS();
  const totalCount = searchProps.paginator.get("totalCount");

  params.total_count = totalCount;
  return (
    <Button
      onClick={() => {
        if (totalCount > EXPORT_LIMIT) {
          toastr.info(
            "Processing",
            "Please check your notifications for completion."
          );
          api.consignments.export(params).then(() => SUCCESS);
        } else {
          window.open(
            `${API_BASE}/consignments/export?${stringify(params)}`,
            "_blank"
          );
          toastr.success(
            "Processing Consignments Report. Please wait for the PDF to generate."
          );
        }
      }}
    >
      Export
    </Button>
  );
};

const meetsExportCriteria = renderIf(() => {
  const user = useCurrentUser();
  return hasRole(user, ADMIN);
});

const DecoratedExportButton = meetsExportCriteria(ExportButton);

function ConsignmentsSearch({ pushHistory }) {
  return (
    <Search search={consignmentsPagination} syncWithUrl>
      {searchProps => (
        <div>
          <div className="form-group form-group-searchbar has-feedback has-feedback-left">
            <i className="text-muted fa fa-search form-control-feedback form-control-feedback-left" />
            <div className="input-group">
              <SearchFilter
                {...searchProps}
                placeholder="Search by typing a company name or consignment reference"
                submitOnSingleResult={r =>
                  pushHistory(`/consignments/${r.uuid}`)}
              />
              <DecoratedExportButton searchProps={searchProps} />
              <CreateButton />
            </div>
          </div>
          <h2>Consignments / EMA</h2>
          <Table {...searchProps} />
          <Pagination {...searchProps} />
        </div>
      )}
    </Search>
  );
}

ConsignmentsSearch.propTypes = {
  pushHistory: PropTypes.func.isRequired
};

export default connect(undefined, { pushHistory: push })(ConsignmentsSearch);



// WEBPACK FOOTER //
// ./app/modules/Consignments/Search/Consignments.jsx